import React, { Component } from "react";

export default class Loading extends Component {
    render() {
        let spinnerSize;
        if (this.props.size) {
            spinnerSize = {
                width: this.props.size + "rem",
                height: this.props.size + "rem"
            };
        }
        return (
            <div className="loading-modal d-flex w-100 h-100 justify-content-center align-items-center">
                <div
                    className="spinner-border text-primary"
                    role="status"
                    style={spinnerSize}
                >
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }
}
